import { request } from '@/utils/request'

export function getRankingDetail (rankId) {
  return request.get(`/ranking/details/${rankId}`)
}

export function getRankList (params = {}) {
  return request.get('/rankdata/list', { params })
}

export function getHotListData (params = {}) {
  return request.get('/hotListData/list', { params })
}
